import React from "react";
import { Container } from "react-bootstrap";
import {Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import classes from './swiperBlock.module.css';
import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';

const SwiperBlock = (props) => {
    return (
        <Container fluid="fluid">
            <Swiper
                slidesPerView={3}
                spaceBetween={30}
                cssMode={true}
                navigation={true}
                pagination={{
                clickable: true,
                }}
                mousewheel={true}
                keyboard={true}
                modules={[Navigation, Pagination, Mousewheel, Keyboard]}
                className={classes.sliderSwiper}
            >
                <SwiperSlide className={classes.swiperSlide}><img src={props.img1} alt="swiper-image" /></SwiperSlide>
                <SwiperSlide className={classes.swiperSlide}><img src={props.img2} alt="swiper-image" /></SwiperSlide>
                <SwiperSlide className={classes.swiperSlide}><img src={props.img3} alt="swiper-image" /></SwiperSlide>
                <SwiperSlide className={classes.swiperSlide}><img src={props.img4} alt="swiper-image" /></SwiperSlide>
            </Swiper>
        </Container>
    )
}

export default SwiperBlock;